module.exports = "{{^Model.Hidden}}\r\n    <td class=\"court-enabled\">\r\n        <input type=\"checkbox\" id=\"{{Model.CourtId}}\" class=\"slider\" value=\"{{Model.Enabled}}\" {{#Model.Enabled}}checked{{/Model.Enabled}}>\r\n    </td>\r\n    <td class=\"court-name\">\r\n        {{Model.CourtName}}\r\n    </td>\r\n    <td class=\"jurisdiction-name\">\r\n        <img src=\"assets/images/flags/32/{{Model.IconUrl}}\" title=\"{{Model.DisplayJurisdiction}}\" width=\"24\" height=\"24\"/>\r\n        {{Model.DisplayJurisdiction}}\r\n    </td>\r\n{{/Model.Hidden}}"


//////////////////
// WEBPACK FOOTER
// ./src/my-justis/views/alerts-court.html
// module id = 365
// module chunks = 1